/**
 * The server's own explanation, in whatever shape it sent it.
 *
 * Nest's validation pipe answers `message: ['a should not be empty', ...]`;
 * a service refusal answers `message: 'one sentence'`. A toast or dialog
 * that prints `[object Object]` (or a raw array) is no better than one that
 * says nothing, so the array is joined and anything else is ignored.
 *
 * Ported verbatim from efiber-dispatch/src/utils/serverReason.js, where it was
 * lifted out of ViewTickets.vue during the W17 round. It arrives here because
 * the Stage 1b sweep found 22 sites in THIS console that discard the response
 * body entirely, and there was no helper here to surface it with -- so without
 * this file each screen would have re-typed its own message extraction and the
 * two consoles would have drifted apart on the one thing a user actually reads.
 *
 * Keep the two copies identical. They are separate published apps with no
 * shared package, so this is a deliberate duplicate, not an oversight: if you
 * change one, change the other.
 */
export function serverReason(data) {
	const message = data?.message;
	if (Array.isArray(message)) return message.join('; ');
	if (typeof message === 'string' && message.trim()) return message;
	return '';
}
